import * as types from './actionType';

export const fetchAuth = () => ({
  type: types.PRIVATE_ROUTE_AUTH_REQUESTED
})

export const fetchLoginCountAction = () => ({
  type: types.LOGINCOUNT_REQUESTED
})